import { Mail, MapPin, Phone } from "lucide-react";

import ContactForm from "../../components/User/Contact/ContactForm";

const locations = [
  {
    title: "Head Office",
    address: "Plot No 270/1410, Pitapalli Square, Khordha, Odisha 752055",
  },
  {
    title: "Bhubaneswar North",
    address:
      "Plot No 134/2502, Ratagharh Lenkasahi, Baranga, Cuttack, Odisha 754005",
  },
  {
    title: "Bhubaneswar South",
    address: "Plot No 270/1411, 1412, Pitapalli Square, Khordha, Odisha 752055",
  },
  {
    title: "Paradip",
    address:
      "Near IOCL Railway Overbridge, Rangaiagarh, Paradip, Odisha 754142",
  },
];

const Contact = () => {
  return (
    <section className="w-full bg-gradient-to-b from-[#fdf5ff] to-white py-12 md:py-16 lg:py-20 px-4 md:px-10 lg:px-16">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-xs font-semibold tracking-[0.25em] uppercase text-[#B3129E]">
            [ LET'S CONNECT ]
          </span>

          <h1 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl tracking-wider text-[#041122] font-semibold font-heading mt-3">
            Get in Touch With Mix Masters
          </h1>

          <p className="text-gray-600 text-sm md:text-base mt-4 max-w-xl mx-auto">
            Whether you're planning a project, exploring partnerships, or need
            support — our team is ready to assist you.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
          {/* Contact Info */}
          <div className="rounded-3xl bg-white border border-purple-100 shadow-md p-8 h-full">
            <h2 className="text-xl font-semibold text-[#041122] mb-6">
              Contact Information
            </h2>

            <div className="space-y-5">
              <div className="flex gap-4">
                <div className="w-10 h-10 rounded-xl bg-[#B3129E] flex items-center justify-center text-white">
                  <Mail size={18} />
                </div>
                <div>
                  <p className="font-semibold text-sm">Email</p>
                  <p className="text-sm text-gray-600">sales@mixmasters.in</p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-10 h-10 rounded-xl bg-[#B3129E] flex items-center justify-center text-white">
                  <Phone size={18} />
                </div>
                <div>
                  <p className="font-semibold text-sm">Customer Care</p>
                  <p className="text-sm text-gray-600">022 6962 0379</p>
                  <p className="text-sm text-gray-600">9124110020</p>
                </div>
              </div>
            </div>

            {/* Locations */}
            <div className="mt-10">
              <h3 className="text-sm font-semibold text-[#041122] mb-4">
                Our Locations
              </h3>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {locations.map((loc) => (
                  <div
                    key={loc.title}
                    className="rounded-xl border border-purple-100 p-4 bg-[#faf5ff] hover:bg-white transition"
                  >
                    <div className="flex gap-3 items-start">
                      <MapPin size={18} className="text-[#B3129E] mt-1" />

                      <div>
                        <p className="text-sm font-semibold">{loc.title}</p>
                        <p className="text-xs text-gray-600 leading-relaxed">
                          {loc.address}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Contact Form */}

          <ContactForm classname="rounded-3xl" inputClassName="rounded-xl" />
        </div>
      </div>
    </section>
  );
};

export default Contact;
